import { render, staticRenderFns } from "./QuestionsView.vue?vue&type=template&id=4dcee94f&"
import script from "./QuestionsView.vue?vue&type=script&lang=ts&"
export * from "./QuestionsView.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionsView.vue?vue&type=style&index=0&id=4dcee94f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports